<template>
    <GiVendorIndex
        pageTitle="Good Issue (DC Karawang)"
        :isCentralWarehouse="true"
        :includeCentralWarehouseParam="true"
        commitRouteName="outbound-delivery-good-issue-dc-karawang-commit"
        :order-type="orderTypeReg"
        :skipWarehouseSelection="true"
    />
</template>

<script>
import GiVendorIndex from "../components/GiVendorIndex.vue";
import { ORDER_TYPE } from "@/constants/outbound";

export default {
    components: {
        GiVendorIndex,
    },

    computed: {
        orderTypeReg() {
            return ORDER_TYPE.REG
        }
    }
}
</script>
